import { ShieldCheck, Truck, Lock, BookOpen } from "lucide-react";
import { IMG, quoteFor, usd } from "@/lib/api";
import { useStore } from "@/lib/store";
import { Reveal, StockPill } from "@/components/site/Reveal";
import { SplitPay } from "@/components/site/SplitPay";

export const BuySection = () => {
  const { stock, initial, openCheckout } = useStore();
  const q = quoteFor(1);
  const soldOut = stock === 0;
  return (
    <section id="buy" data-testid="buy-section" className="grain relative overflow-hidden bg-[#F2EAE1] py-20 sm:py-28">
      <div className="relative mx-auto grid max-w-[1400px] items-center gap-12 px-5 sm:px-8 lg:grid-cols-2">
        <Reveal>
          <div className="relative aspect-square overflow-hidden rounded-[32px] bg-[#E8DCCD]">
            <img src={IMG.studio} alt="The Slowpour 01" className="h-full w-full object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <StockPill stock={stock} initial={initial} testId="buy-inventory-badge" />
          <h2 className="font-display mt-6 text-5xl font-light leading-none tracking-tight sm:text-6xl">The Slowpour <span className="italic text-[#C85A32]">01</span></h2>
          <p className="mt-4 text-base text-[#4A4543] md:text-lg">Self-feeding slow masticating juicer · Matte black</p>
          <dl className="mt-8 max-w-md space-y-3 border-y border-[#181615]/10 py-6 text-sm">
            <div className="flex justify-between"><dt>Juicer</dt><dd data-testid="buy-price">{usd(q.subtotal)}</dd></div>
            <div className="flex justify-between"><dt>Flat-rate shipping</dt><dd>{usd(q.shipping)}</dd></div>
            <div className="flex justify-between"><dt>Sales tax (8.85%)</dt><dd>{usd(q.tax)}</dd></div>
            <div className="flex justify-between"><dt className="flex items-center gap-2"><BookOpen size={14} /> Recipe Almanac PDF</dt><dd className="text-[#5E7153]">Free</dd></div>
            <div className="flex justify-between border-t border-[#181615]/10 pt-3 text-base font-semibold"><dt>Total</dt><dd data-testid="buy-total">{usd(q.total)}</dd></div>
          </dl>
          <button
            data-testid="buy-section-checkout-button"
            disabled={soldOut}
            onClick={openCheckout}
            className="mt-8 w-full max-w-md rounded-full bg-[#181615] py-4 font-semibold text-[#FDFBF7] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#C85A32] disabled:cursor-not-allowed disabled:opacity-50"
          >
            {soldOut ? "Sold out" : "Buy now — $250"}
          </button>
          <div className="mt-4 max-w-md"><SplitPay total={q.total} testId="buy-split-pay-note" /></div>
          <ul className="mt-6 grid max-w-md grid-cols-3 gap-3 text-xs text-[#4A4543]">
            <li className="flex items-center gap-1.5"><Lock size={14} /> Stripe secure</li>
            <li className="flex items-center gap-1.5"><Truck size={14} /> Ships in 1–2 days</li>
            <li className="flex items-center gap-1.5"><ShieldCheck size={14} /> BPA-free</li>
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
